import { render, staticRenderFns } from "./WebhooksList.vue?vue&type=template&id=2c419681&scoped=true"
import script from "./WebhooksList.vue?vue&type=script&lang=js"
export * from "./WebhooksList.vue?vue&type=script&lang=js"
import style0 from "./WebhooksList.vue?vue&type=style&index=0&id=2c419681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c419681",
  null
  
)

export default component.exports